import { render } from "./MultiSliderComponent.vue?vue&type=template&id=6aa54740"
import script from "./MultiSliderComponent.vue?vue&type=script&lang=js"
export * from "./MultiSliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__